import { NgModule } from "@angular/core";
import { PhoneNumberDirective } from "@app/components/misc/phoneNumber/phoneNumber.directive";
import { AllowPatternDirective } from "@app/components/allowPattern/allowPattern.directive";
import { CustomCurrencyDirective } from "@app/components/misc/customCurrencyDirective/customCurrency.directive";
import { HoaIfOverFlowXClassDirective } from "@app/components/misc/ifoverflow/ifoverflowxclass";
import { BlankWhenZeroDirective } from "@app/components/misc/blankWhenZeroDirective/blankWhenZero.directive";
import { HeaderBarDirective } from "@app/components/header/header.bar.directive";
import { NumbersOnlyDirective } from "@app/components/misc/numbersOnlyDirective/numbersOnly.directive";
import { StopCCPDirective } from "@app/components/stopccp/stopccp";

@NgModule({
    declarations: [
        PhoneNumberDirective,
        AllowPatternDirective,
        CustomCurrencyDirective,
        HoaIfOverFlowXClassDirective,
        BlankWhenZeroDirective,
        HeaderBarDirective,
        NumbersOnlyDirective,
        StopCCPDirective,
    ],
    exports: [
        PhoneNumberDirective,
        AllowPatternDirective,
        CustomCurrencyDirective,
        HoaIfOverFlowXClassDirective,
        BlankWhenZeroDirective,
        HeaderBarDirective,
        NumbersOnlyDirective,
        StopCCPDirective,
    ],
})
export class DirectivesModule {

}
